import { useEffect } from 'react';
import { useQuery } from '@apollo/client';

import { GET_APP_LEVEL_MODALS_DATA } from '../../../../graphql/app-level-modals/queries/get-modals-data';
import { IAppLevelModalsData } from '../../../../graphql/app-level-modals/models/get-modals-data.model';
import { usePurchasesConsumerBanModal } from './modals/purchases-consumer-ban/purchases-consumer-ban';
import { useBirthdayPointsModal } from './modals/birthday-points';
import { withAuthorization } from './hocs/with-authorization';
import { useOrderCancelledModal } from './modals/order-cancellation/order-cancellation';

const AppLevelModalsComponent = (): null => {
  const { data } = useQuery<IAppLevelModalsData>(GET_APP_LEVEL_MODALS_DATA, {
    pollInterval: 60000,
  });
  const { handleBirthdayPointsModal } = useBirthdayPointsModal();
  const { handlePurchasesConsumerBanModal } = usePurchasesConsumerBanModal();
  const { handleOrderCancelModal } = useOrderCancelledModal();

  useEffect(() => {
    if (data) {
      const {
        notificationByAuthId,
        pointsTransactionByAuthIdAndType,
        notificationsNCByAuthId,
      } = data;

      // modals should appear in certain order
      handleBirthdayPointsModal(notificationByAuthId, pointsTransactionByAuthIdAndType);
      handlePurchasesConsumerBanModal(notificationByAuthId);
      handleOrderCancelModal(notificationsNCByAuthId);
    }
  }, [data]);

  return null;
};

export const AppLevelModals = withAuthorization(AppLevelModalsComponent);
